module.exports = __webpack_public_path__ + "static/media/bulle-poils.02acdf6b.png";